//@ts-check
//@ts-ignore
import Result from './result.riot';
import { connect } from '@/common/lib/riot-redux';

const mapStateToProps = (state) => {
  return {
    shopId: state.app.shopId,
    result: state.app.result
  };
};

export default connect(Result, mapStateToProps, null);